import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import userApi from "service/userApi";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import {
  getListQuanLyThuChiNgoaiLe,
  updateDataSearch,
} from "../../../actions/QuanLyThuChiNgoaiLe";
import QuanLyThuChiNgoaiLeApi from "../../../service/quanLyThuChiNgoaiLeApi";
import { useSelector, useDispatch } from "react-redux";

export const ModalSearchNangCaoMobile = (props) => {
  const dispatch = useDispatch();

  const DanhSachLoai = {
    loaiOption: [
      {
        label: "Loại phiếu",
        value: "0",
      },
      {
        label: "Nhập hàng",
        value: "NH",
      },
      {
        label: "Bán hàng",
        value: "BH",
      },
      {
        label: "Phí sản xuất",
        value: "PSX",
      },
    ],
  };
  const [listLoai, setListLoai] = useState(DanhSachLoai.loaiOption);
  useEffect(() => {
    //Code lấy list user
    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });
    QuanLyThuChiNgoaiLeApi.totalLoaiThuChi().then((response) => {
      const dataComboLoai = response.data.map((item) => ({
        value: item.Value,
        label: item.Text,
      }));
      setListLoai(dataComboLoai);
    });

    // const newData = [...listLoai, ...loaiPhieuChi, ...loaiPhieuThu];
    // console.log(newData, "1loaithuchi");
    // setLoaiPhieuThuChi(newData);
  }, []);
  const DanhSachCombo = {
    nhanVienOption: [
      {
        label: "Test828@gmail.com",
        value: "Test828@gmail.com",
      },
      {
        label: "Test@gmail.com",
        value: "Test@gmail.com",
        selected: true,
      },
    ],
  };
  const [listUser, setListUser] = useState(DanhSachCombo.nhanVienOption);
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiNgoaiLe
  );
  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    props.onHide(false);
    dataSearch.pageIndex = 1;
    dispatch(getListQuanLyThuChiNgoaiLe(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      dispatch(getListQuanLyThuChiNgoaiLe(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  // convert sự kiện tìm kiếm từ ngày đến ngày
  var tungay = currentDate();
  if (dataSearch.tungay === "01/01/2001") tungay = "";
  else tungay = dataSearch.tungay;
  var denngay = currentDate();
  if (dataSearch.denngay === "01/01/4000") denngay = "";
  else denngay = dataSearch.denngay;
  denngay = convertDate(denngay);
  tungay = convertDate(tungay);
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-file-search"></i>
          </span>{" "}
          Tìm kiếm nâng cao
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="row repeater-default">
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="email-addr">Từ ngày</label>
              <br />
              <DateTimePicker
                value={tungay}
                onChange={onChangeDate("tungay")}
                placeholder="Từ ngày"
                name="tungay"
              ></DateTimePicker>
            </div>
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="email-addr">Đến ngày</label>
              <br />
              <DateTimePicker
                value={denngay}
                onChange={onChangeDate("denngay")}
                placeholder="Đến ngày"
                name="denngay"
              ></DateTimePicker>
            </div>
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="bio" className="cursor-pointer">
                Nhân viên
              </label>
              <select
                name="nhanvien"
                className="selectBox form-control input-sm"
                value={dataSearch.nhanvien}
                onChange={updateDropdown("nhanvien")}
              >
                {listUser &&
                  listUser.map((item, idx) => (
                    <option key={"objComboStore1" + idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select>
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="tel-input">Loại phiếu</label>
              <select
                name="nhanvien"
                className="selectBox form-control input-sm"
                value={dataSearch.loaiphieu}
                onChange={updateDropdown("loaiphieu")}
              >
                {listLoai &&
                  listLoai.map((item, idx) => (
                    <option key={"objComboStore1" + idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSearch}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-magnify"></i>
          </span>
          Tìm kiếm
        </a>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
